/**
 * @class
 * @param {String} id         an id representing the object (ex: the LID or OID)
 * @param {Number} latitude   the latitude
 * @param {Number} longitude  the longitude
 * @param {Object} o          options object
 *                              shortPrice
 *                              card
 */
define(['jquery'], function ($) {
   "use strict";

   return function (id, latitude, longitude, oConfig) {
      var self = this,
         m_id = id,
         m_iLatitude = latitude,
         m_iLongitude = longitude,
         m_oConfig = oConfig || {},
         m_jCard = m_oConfig.card || $(),
         m_strShortPrice = m_oConfig.shortPrice;

      self.getId = function () {
         return m_id;
      };

      self.getLatitude = function () {
         return m_iLatitude;
      };

      self.getLongitude = function () {
         return m_iLongitude;
      };

      self.getLocation = function () {
         return new window.Microsoft.Maps.Location(m_iLatitude, m_iLongitude);
      };

      self.getShortPrice = function () {
         return m_strShortPrice;
      };

      self.getCard = function () {
         return m_jCard;
      };

      self.getData = function (key) {
         return m_oConfig[key];
      };

      // For compatibility with Microsoft clustering plugin... do not use
      self.Latitude = latitude;
      self.Longitude = longitude;
   };
});
